import { Component, Inject, OnDestroy } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-analysis-html-dialog',
  templateUrl: './analysis-html-dialog.component.html',
  standalone: true,
  styleUrls: ['./analysis-html-dialog.component.scss']
})
export class AnalysisHtmlDialogComponent implements OnDestroy {
  htmlSanitized: SafeResourceUrl;
  private url?: string;

  constructor(
    public dialogRef: MatDialogRef<AnalysisHtmlDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public html: string,
    private sanitizer: DomSanitizer
  ) {
    // Crea un Blob y ObjectURL para HTML largo (mas seguro, sin limite real de tamaño)
    const blob = new Blob([this.html], { type: 'text/html' });
    this.url = URL.createObjectURL(blob);
    this.htmlSanitized = this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
  }

  ngOnDestroy() {
    if (this.url) {
      URL.revokeObjectURL(this.url);
    }
  }
}
